export default __webpack_public_path__ + "static/media/pinterest-icon.a33a51a1.png";